import { getPermission, IMenuItem } from 'O3_core';
import {
  EMAIL_QUEUE_RESOURCE,
  EMAIL_QUEUE_SCOPES,
} from '../email-queue/constants/email-queue.constants';
import {
  SMS_QUEUE_RESOURCE,
  SMS_QUEUE_SCOPES,
} from '../sms-queue/constants/sms-queue.constants';

export const NotificationsSMIs: IMenuItem[] = [
  {
    id: '11000',
    label: 'sideMenuItems.notifications._label',
    icon: 'ti ti-bell',
    items: [
      {
        id: '11001',
        label: 'sideMenuItems.notifications.dashboard',
        icon: 'ti ti-layout-dashboard',
        routerLink: '/notifications',
        permission: getPermission(
          EMAIL_QUEUE_RESOURCE,
          EMAIL_QUEUE_SCOPES.sideMenuItem,
        ),
      },
      {
        id: '11002',
        label: 'sideMenuItems.notifications.emailQueue',
        icon: 'ti ti-mail',
        routerLink: '/notifications/email-queue',
        permission: getPermission(
          EMAIL_QUEUE_RESOURCE,
          EMAIL_QUEUE_SCOPES.sideMenuItem,
        ),
      },
      {
        id: '11003',
        label: 'sideMenuItems.notifications.smsQueue',
        icon: 'ti ti-message',
        routerLink: '/notifications/sms-queue',
        permission: getPermission(
          SMS_QUEUE_RESOURCE,
          SMS_QUEUE_SCOPES.sideMenuItem,
        ),
      },
    ],
  },
];
